import { connect } from 'react-redux'

import { CONTACTS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './Contacts'

function mapStateToProps(state) {
  return {
    coordinates: state.localization.coordinates,
  }
}

const LocalizedComponent = withLocalization(Component, CONTACTS)

export default connect(mapStateToProps, null)(LocalizedComponent)
